import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeIn } from 'src/transitions';

@Component({
  selector: 'app-pool',
  standalone: false,
  templateUrl: './pool.component.html',
  styleUrls: ['./pool.component.scss'],
  animations: [ fadeIn ]
})
export class PoolComponent implements OnInit {

  // Demo data – no API/controller logic yet. Replace with real data later.
  pool : any = {
    Id: 1,
    Name: 'Senior Software Engineers',
    Description: 'Talentpool für erfahrene Backend- und Fullstack-Entwickler:innen im Raum München.',
    Image: null,
    CandidateCount: 42
  };

  view = 'activities';

  // ?obfuscate shows demo content in both views, so it survives the switch
  obfuscate = false;

  state = 'out';

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe((params: any) => {
      this.view = params.view ?? 'activities';
      this.obfuscate = params.obfuscate != null;
    });

    // Show demo data immediately.
    this.state = 'in';
  }

  activateView(v) {
    var uri = '/pool?view=' + v;
    if (this.obfuscate) uri += '&obfuscate=1';
    this.router.navigateByUrl(uri);
  }

}
